<template>
  <Message type="warning" v-if="unauthenticatedAccounts.length || groupSettingUnauthenticatedAccounts.length">
    <div class="campaign-twitter-authentication">
      <div>
        キャンペーン実施予定のアカウントにて、データ収集のためのAPI認証をしてください。
        <br />
        開催日時までに認証をしない場合、応募データが収集されません。詳細は<a
          href="https://help-atelu.comnico.jp/ntt-api-authentication"
          target="_blank"
          rel="noopener noreferrer"
          >こちら</a
        >をご覧ください。
      </div>
      <div class="campaign-account-name" v-for="account of unauthenticatedAccounts" :key="account.id">
        <Account :name="account.name" :image="account.pictureUrl" :symbol="twitter" />
        <el-button type="twitter" @click="updateAccountToken(account)"> データ収集API認証 </el-button>
      </div>
      <div class="campaign-account-name" v-for="account of groupSettingUnauthenticatedAccounts" :key="account.id">
        <Account :name="account.name" :image="account.pictureUrl" :symbol="twitter" />
        <el-button type="twitter" @click="updateAccountToken(account)"> データ収集API認証 </el-button>
      </div>
    </div>
  </Message>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'
import Message from '@/client/components/_atoms/Message.vue'
import Account from '@/client/components/_molecules/Account.vue'
import api from '@/client/core/api'
import TwitterAuthService from '@/client/core/twitter_auth'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useSettingGroupStore } from '@/client/store/useSettingGroupStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { TCampaignAccount } from '@/typings/api/campaign_accounts.type'
export default defineComponent({
  components: {
    Icon,
    Message,
    Account
  },
  props: {
    isGroupSetting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useCampaignStore, ['unauthenticatedAccounts']),
    ...mapState(useSystemStore, {
      currentGroup: state => state.currentGroup,
      guestGroups: state => state.guestGroups
    }),
    ...mapState(useSettingGroupStore, ['groupSettingUnauthenticatedAccounts'])
  },
  data() {
    return {
      twitter: 'twitter'
    }
  },
  methods: {
    ...mapActions(useSettingGroupStore, ['fetchAccounts']),
    /**
     * アカウントトークンの更新
     */
    async updateAccountToken(account: TCampaignAccount) {
      await this.updateTwitterAccountToken(account)

      if (this.isGroupSetting) {
        const { shouldLeaveGroupSetting } = await this.fetchAccounts(this.currentGroup.id)

        if (shouldLeaveGroupSetting) {
          this.$router.push('/campaigns')
        }

        return
      }

      // キャンペーン一覧を取得
      // キャンペーン一覧の更新を親コンポーネントに通知
      this.$emit('campaignUpdated')
    },
    /**
     * Twitterアカウントトークンの更新
     */
    async updateTwitterAccountToken(apiAccount: TCampaignAccount) {
      if (!apiAccount.accountId) return

      const enterpriseAuth = await TwitterAuthService.execEnterpriseAuth(apiAccount.accountId)

      if (!enterpriseAuth) {
        this.$notify({
          title: '認証に失敗しました。',
          message: '恐れ入りますが、時間を置いて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      const account = {
        id: enterpriseAuth.id,
        enterpriseToken: enterpriseAuth.enterpriseToken,
        enterpriseSecret: enterpriseAuth.enterpriseSecret
      }

      const result = await api.put('/twitter_campaign_accounts/' + apiAccount.id, {
        enterpriseToken: account.enterpriseToken,
        enterpriseSecret: account.enterpriseSecret
      })

      if (result?.error?.type === 'NOT_MATCH') {
        const errorText = '認証したアカウントが違うため、データ収集API認証に失敗しました。'

        this.$notify({
          title: errorText,
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      if (!result.data) {
        const errorText = 'データ収集API認証に失敗しました。'

        this.$notify({
          title: errorText,
          message: '恐れ入りますが、時間を置いて再度お試しください。',
          customClass: 'danger',
          duration: 5000
        })
        return
      }

      // 成功メッセージを表示
      this.$notify({
        title: `${apiAccount.name}のデータ収集API認証が完了しました。`,
        customClass: 'success',
        duration: 5000
      })
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-twitter-authentication {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit * 2;
  color: $text-color;
}

.campaign-account-name {
  display: flex;
  flex-direction: row;
  gap: $spacing-unit;
}
</style>
